<template>
  <Modal class="long-modal top-modal"  width="800" style="max-height:80%; over-flow:auto"  v-model="show" :mask-closable="false" >
    <div slot="header" class="modal-header">智能设备详情</div>
    <div class=" pt16 pb16">
      <table-list :showPage ="false" :columns="columns" :data="tableData" :loading="loading"></table-list>
    </div>
    <div slot="footer">
      <div>
        <Button  type="primary" size="large" @click="close">确定</Button>
      </div>
    </div>
  </Modal>
</template>

<script type="text/ecmascript-6">
 import TableList from "components/TableList/index";
 import { intellectDetail } from "api/smartWorkOrder"

export default {
  components:{
    TableList
  },
  props:{
    n:{
      type:Number,
      default:0
    },
    projectFid:{
      type:String,
      default:''
    },
    stockParentFid:{
      type:String,
      default:''
    },
    stockFid:{
      type:String,
      default:''
    },
    stockNumber:{
      type:String,
      default:''
    }
  },
  watch:{
    n() {
      this.show = true

      let posRank2;
      let posRank3;
      if(this.stockParentFid && this.stockFid) {
        posRank2 = this.stockParentFid
        posRank3 = this.stockFid
      } else {
        posRank2 = this.stockFid
      }

      let params={
        posRank1: this.projectFid,
        posRank2: posRank2,
        posRank3: posRank3
      }
      this.tableData = []
      this.loading = true
      intellectDetail(params).then( res => {
        this.tableData = res.data
      }).finally( () => {
        this.loading = false
      })
    }
  },

 data () {
  return {
    tableData:[],
    show:false,
    loading:false,
    columns:[
      {
        type: "index",
        key: "index",
        width: 60,
        align: "center"
      },
      {
        title:' ',
      },
      {
        title: "房间",
        width:80,
        key: "createTime",
        align: "center",
        render: (h, params) => {
          return h('span', this.stockNumber)
        }
      },
      {
        title:' ',
      },
      {
        title: "位置",
        width:80,
        key: "areaTypeName",
        align: "center"

      },
      {
        title:' ',
      },
      {
        title: "设备名称",
        width:140,
        key: "prodTypeName",
        align: "center"

      },
      {
        title:' ',
      },
      {
        title: "状态",
        width:80,
        key: "isOnlineName",
        align: "center"
      },
      {
        title:' ',
      },
      {
        title: "品牌",
        width:120,
        key: "supName",
        align: "center"
      },
      {
        title:' ',
      },
      {
        title: "电量",
        width:80,
        key: "powerPercent",
        align: "center"
      }
    ]
  };
 },
 methods:{
   close() {
     this.show = false
   }
 }
}
</script>




